export const replaceMatchFieldString = (str: string) => {
  let matchValue;
  switch (str) {
    case 'Custom SKU':
      matchValue = 'shop_sku';
      break;
    case 'Manufacturer SKU':
      matchValue = 'man_sku';
      break;
    case 'System ID':
      matchValue = 'cust_uid';
      break;
    case 'EAN':
      matchValue = 'ean';
      break;
    case 'UPC':
      matchValue = 'upc';
      break;
    default:
  }

  return matchValue;
};

export const replaceSystemIdFieldString = (str: string) => {
  let matchValue;
  switch (str) {
    case 'CUSTOM_SKU':
      matchValue = 'Custom SKU';
      break;
    case 'MANUFACTURER_SKU':
      matchValue = 'Manufacturer SKU';
      break;
    case 'SYSTEM_ID':
      matchValue = 'System ID';
      break;
    case 'EAN':
      matchValue = 'EAN';
      break;
    case 'UPC':
      matchValue = 'UPC';
      break;
    default:
  }

  return matchValue;
};
